var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:timeline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.9999 29H20.7999C20.2999 29 19.7999 28.8 19.3999 28.4L15.6999 24.7C15.2999 24.3 15.2999 23.7 15.6999 23.3L19.3999 19.6C19.7999 19.2 20.2999 19 20.7999 19H41.9999C42.5999 19 42.9999 19.4 42.9999 20V28C42.9999 28.6 42.5999 29 41.9999 29Z",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 6H11V42H9V6Z",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10 27C11.6569 27 13 25.6569 13 24C13 22.3431 11.6569 21 10 21C8.34315 21 7 22.3431 7 24C7 25.6569 8.34315 27 10 27Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10 41C11.6569 41 13 39.6569 13 38C13 36.3431 11.6569 35 10 35C8.34315 35 7 36.3431 7 38C7 39.6569 8.34315 41 10 41Z",
    fill: "#90A4AE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.9999 43H20.7999C20.2999 43 19.7999 42.8 19.3999 42.4L15.6999 38.7C15.2999 38.3 15.2999 37.7 15.6999 37.3L19.3999 33.6C19.7999 33.2 20.2999 33 20.7999 33H33.9999C34.5999 33 34.9999 33.4 34.9999 34V42C34.9999 42.6 34.5999 43 33.9999 43Z",
    fill: "#448AFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.9999 15H20.7999C20.2999 15 19.7999 14.8 19.3999 14.4L15.6999 10.7C15.2999 10.3 15.2999 9.7 15.6999 9.3L19.3999 5.6C19.7999 5.2 20.2999 5 20.7999 5H34.9999C35.5999 5 35.9999 5.4 35.9999 6V14C35.9999 14.6 35.5999 15 34.9999 15Z",
    fill: "#00BCD4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.492f11199d53da581b12baa29aafdb66.svg";
export { ForwardRef as ReactComponent };